import empty from "../assets/53207-empty-file.json";
import camera from '../assets/lottieCameraLoading.json';
import Lottie from "lottie-react";

export default function AppLoadingAnimation ({type}) {

    if (type === 'camera'){
        return (<Lottie animationData={camera} />)
    }

    if (type === "empty") {
        return (<Lottie  style={{height: 300}} animationData={empty} />)
    }
    return (<Lottie animationData={type === "face" ? camera : camera} />)
}